import { useState } from "react";
import PurchaseHistory from "./PurchaseHistory";
import Purchases from "./Purchases";

export default function PurchaseLayout() {
  /*   All States
   ********************************************* */
  const [active, setActive] = useState("purchases");

  /*   All Functions
   ********************************************* */

  /*   All UseEffects
   ********************************************* */
  return (
    <div>
      <div className="">
        <div>
          <button
            className={`btn ${
              active === "purchases" ? "btn-primary" : "btn-light"
            }`}
            onClick={(e) => {
              setActive("purchases");
            }}
          >
            Purchase
          </button>

          <button
            className={`btn ${
              active === "purchaseHistory" ? "btn-primary" : "btn-light"
            }`}
            onClick={(e) => {
              setActive("purchaseHistory");
            }}
          >
            Purchase History
          </button>
        </div>

        {active === "purchases" && (
          <div>
            <Purchases />
          </div>
        )}
        {active === "purchaseHistory" && (
          <div>
            <PurchaseHistory />
          </div>
        )}
      </div>
    </div>
  );
}
